var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSimboloDeArquivoTxt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "512.000000pt",
    height: "512.000000pt",
    viewBox: "0 0 512.000000 512.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,512.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M830 5104 c-42 -18 -86 -58 -108 -99 -15 -27 -17 -109 -20 -871 l-3 -842 -92 -4 c-112 -5 -179 -32 -235 -92 -81 -88 -77 -39 -77 -946 0 -801 0 -805 21 -851 54 -116 140 -169 291 -177 l92 -5 3 -536 c3 -588 1 -562 65 -623 65 -62 -61 -58 1793 -58 1854 0 1728 -4 1793 58 64 61 62 35 65 623 l3 536 92 5 c151 8 237 61 291 177 21 46 21 50 21 851 0 907 4 858 -77 946 -56 60 -123 87 -235 92 l-93 4 -1 302 c-1 165 -4 312 -8 326 -8 30 -994 1160 -1033 1184 -24 15 -138 16 -1270 16 -1088 -1 -1247 -3 -1278 -16z m2400 -714 l0 -530 29 -32 29 -33 466 -3 466 -3 0 -249 0 -250 -1660 0 -1660 0 0 815 0 815 1165 0 1165 0 0 -530z m-1460 -1515 l0 -145 -205 0 -205 0 0 -605 0 -605 -170 0 -170 0 0 605 0 605 -200 0 -200 0 0 145 0 145 575 0 575 0 0 -145z m599 -37 c48 -101 103 -218 122 -260 19 -43 36 -78 39 -78 3 0 20 39 39 88 19 48 70 165 114 260 l80 172 194 0 193 0 -14 -22 c-29 -48 -397 -689 -402 -702 -4 -11 275 -507 418 -743 l20 -33 -196 0 -196 0 -136 272 -136 273 -20 -50 c-10 -28 -65 -150 -120 -273 l-102 -222 -194 0 -194 0 19 33 c11 17 108 188 217 379 l198 347 -206 364 c-113 200 -206 367 -206 371 0 3 86 6 191 6 l191 0 87 -182z m2036 37 l0 -140 -202 -3 -203 -2 0 -605 0 -605 -170 0 -170 0 0 605 0 605 -202 2 -203 3 -3 143 -3 142 578 -2 578 -3 0 -140z m-185 -2135 l0 -480 -1660 0 -1660 0 0 480 0 480 1660 0 1660 0 0 -480z"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSimboloDeArquivoTxt);
export default __webpack_public_path__ + "static/media/simbolo-de-arquivo-txt.a0c62e7c0724d6130f6aade1105c1ef3.svg";
export { ForwardRef as ReactComponent };